module.exports = __webpack_public_path__ + "8b37eb76a2a0b4ddadfd6237ae6573bf.png";